import { createContext } from "react";
const FeatureContext = createContext({});

export default FeatureContext;
